const paths = {
  listForms: '/form/list',
  editForms: '/form/edit',
  answersReportForms: '/form/answersReport',
  reportForms: '/form/report',
  reportAnswerForms: '/form/answerReport'
};

export default paths;
